export default __webpack_public_path__ + "static/media/shopping-cart.1dcb25a8.png";